import type { Partner } from '../../api.js';
import type { Tenant } from '../../types.js';

export interface PartnerSelectOption {
  value: string;
  name: string;
  suspended: boolean;
  disabled: boolean;
}

export function partnerSelectOptions(partners: Partner[]): PartnerSelectOption[] {
  return [...partners]
    .sort(
      (left, right) =>
        Number(left.status === 'suspended') - Number(right.status === 'suspended') ||
        left.name.localeCompare(right.name) ||
        left.id.localeCompare(right.id)
    )
    .map((partner) => ({
      value: partner.id,
      name: partner.name,
      suspended: partner.status === 'suspended',
      disabled: partner.status === 'suspended',
    }));
}

export function owningPartnerLabel(tenant: Tenant, partners: Partner[]): string | undefined {
  if (!tenant.partnerId) return undefined;
  return partners.find((partner) => partner.id === tenant.partnerId)?.name ?? tenant.partnerId;
}
